import React, { createContext, useContext, useState, ReactNode } from 'react';

export type MainNavItem = {
    label: string;
    icon?: string;
    url: string;
};

interface MainNavContextValue {
    mainNavVisible: boolean;
    setMainNavVisible: React.Dispatch<React.SetStateAction<boolean>>;
    mainNavItems: MainNavItem[];
    setMainNavItems: React.Dispatch<React.SetStateAction<MainNavItem[]>>;
    mobileBottomNavIsVisible: boolean;
    setMobileBottomNavIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const MainNavContext = createContext<MainNavContextValue | undefined>(undefined);

export const MainNavProvider = ({ children }: { children: ReactNode }) => {
    const [mainNavVisible, setMainNavVisible] = useState(false);
    const [mainNavItems, setMainNavItems] = useState<MainNavItem[]>([]);
    const [mobileBottomNavIsVisible, setMobileBottomNavIsVisible] = useState(true);

    return (
        <MainNavContext.Provider
            value={{
                mainNavVisible,
                setMainNavVisible,
                mainNavItems,
                setMainNavItems,
                mobileBottomNavIsVisible,
                setMobileBottomNavIsVisible
            }}
        >
            {children}
        </MainNavContext.Provider>
    );
};

export const useMainNav = (): MainNavContextValue => {
    const context = useContext(MainNavContext);
    if (context === undefined) {
        throw new Error('useMainNav must be used within a MainNavProvider');
    }
    return context;
};
